import { defineMessages } from 'react-intl';

export const accountingRangesMessages = defineMessages({
    accountingRanges: {
        id: 'accounting-ranges',
        defaultMessage: 'Accounting ranges',
    },
    accountingRange: {
        id: 'accounting-range',
        defaultMessage: 'Accounting range',
    },
    ranges: {
        id: 'ranges',
        defaultMessage: 'Ranges',
    },
    range: {
        id: 'range',
        defaultMessage: 'Range',
    },
    start: {
        id: 'start',
        defaultMessage: 'Start',
    },
    end: {
        id: 'end',
        defaultMessage: 'End',
    },
    isManual: {
        id: 'is-manual',
        defaultMessage: 'Is manual',
    },
    createAccountingRangeSuccess: {
        id: 'create-accounting-range-success',
        defaultMessage: 'Accounting range created',
    },
    createAccountingRangeSuccessDescription: {
        id: 'create-accounting-range-success-description',
        defaultMessage: 'Accounting range {entry} has been successfully created.',
    },
    addAccountingRangeSubtitle: {
        id: 'add-accounting-range-subtitle',
        defaultMessage: 'Create a new accounting range',
    },
    deleteAccountingRange: {
        id: 'delete-accounting-range',
        defaultMessage: 'Delete accounting range',
    },
    deleteAccountingRangeSuccess: {
        id: 'delete-accounting-range-success',
        defaultMessage: 'Accounting range deleted',
    },
    deleteAccountingRangeSuccessDescription: {
        id: 'delete-accounting-range-success-description',
        defaultMessage: 'The accounting range has been successfully deleted.',
    },
    confirmDeleteAccountingRange: {
        id: 'confirm-delete-accounting-range',
        defaultMessage: 'Are you sure you want to delete this accounting range? This action cannot be undone.',
    },
    deleteAccountingRangeSubtitle: {
        id: 'delete-accounting-range-subtitle',
        defaultMessage: 'Permanently delete accounting range {entity}',
    },
    editAccountingRangeSubtitle: {
        id: 'edit-accounting-range-subtitle',
        defaultMessage: 'Edit accounting range {entity}',
    },
    updateAccountingRangeSuccess: {
        id: 'update-accounting-range-success',
        defaultMessage: 'Accounting range updated',
    },
    updateAccountingRangeSuccessDescription: {
        id: 'update-accounting-range-success-description',
        defaultMessage: 'Accounting range {entity} has been successfully updated.',
    },
    accountingRangeDashboard: {
        id: 'accounting-range-dashboard',
        defaultMessage: 'Accounting range dashboard',
    },
    backToAllAccountingRanges: {
        id: 'back-to-all-accounting-ranges',
        defaultMessage: 'Back to all accounting ranges',
    },
    duplicatedAccountingRangeError: {
        id: 'custom-error:duplicate_accounting_range',
        defaultMessage: 'Cannot have duplicate accounting ranges!',
    },
});
